/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />


abstract class BaseService{
    constructor(){
    }
}
export{BaseService};

